import { render, staticRenderFns } from "./AdminUserList.vue?vue&type=template&id=32a88c34&scoped=true"
import script from "./AdminUserList.vue?vue&type=script&lang=js"
export * from "./AdminUserList.vue?vue&type=script&lang=js"
import style0 from "./AdminUserList.vue?vue&type=style&index=0&id=32a88c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a88c34",
  null
  
)

export default component.exports